import type { Folder } from '../types';
import { USE_BACKEND } from '../config/env';

export interface FolderService {
    createFolder(name: string): Promise<Folder>;
    deleteFolder(id: number | string): Promise<void>;
    getFolders(): Promise<Folder[]>;
    getAllFolders(): Promise<Folder[]>;
}

// Dynamic service selection based on feature flag
async function createService(): Promise<FolderService> {
    if (USE_BACKEND) {
        const { apiFolderService } = await import('./folderService.api');
        return apiFolderService as unknown as FolderService; // Type adapter for legacy interface
    } else {
        const { MockFolderService } = await import('./folderService.mock');
        return new MockFolderService();
    }
}

// Service instance (lazy-loaded)
let serviceInstance: Promise<FolderService> | null = null;

function getService(): Promise<FolderService> {
    if (!serviceInstance) {
        serviceInstance = createService();
    }
    return serviceInstance;
}

// Export unified service interface
export const folderService: FolderService = {
    async createFolder(name: string): Promise<Folder> {
        const service = await getService();
        return service.createFolder(name);
    },

    async deleteFolder(id: number): Promise<void> {
        const service = await getService();
        return service.deleteFolder(id);
    },

    async getFolders(): Promise<Folder[]> {
        const service = await getService();
        return service.getFolders();
    },

    async getAllFolders(): Promise<Folder[]> {
        const service = await getService();
        return service.getAllFolders();
    }
};